var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"sonar-view",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.projects),function(project){return _c('project-card',{key:project.key,attrs:{"project":project}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }